import { SvgIcon } from '@mui/material';

export default function LaneLeftHandIcon(props) {
  return (
    <SvgIcon fill='none' fontSize='large' {...props}>
      <path
        d='M 12.3277,11.6154 11.62,10.9077 16.2142,6.3077 11.62,1.7077 12.3277,1 17.6354,6.3077 Z m 6.1,0 -0.7077,-0.7077 4.5942,-4.6 L 17.72,1.7077 18.4277,1 23.7354,6.3077 Z'
        id='path1'
      />
      <path
        d='M 6.16769,23.0004 0.859993,17.6927 6.16769,12.385 l 0.7077,0.7077 -4.59422,4.6 4.59422,4.6 z m 6.10001,0 -5.30771,-5.3077 5.30771,-5.3077 0.7077,0.7077 -4.59423,4.6 4.59423,4.6 z'
        id='path2'
      />
    </SvgIcon>
  );
}
